/**
 * Fetch aggregate stats for a single chatbot_setting (counts per status).
 */
import { useEffect, useRef, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import chatbotApi from "../../../api/chatbotApi";

const EMPTY_STATS = {
  total: 0,
  pending: 0,
  scheduled: 0,
  sending: 0,
  sent: 0,
  received: 0,
  seen: 0,
  failed: 0,
  dead: 0,
};

export const useBotStats = (settingId, { dateFrom, dateTo } = {}) => {
  const accountId = useSelector((state) => state.auth.user?.accountId);
  const [stats, setStats] = useState(EMPTY_STATS);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const requestIdRef = useRef(0);

  const filterKey = JSON.stringify({ dateFrom, dateTo });

  const fetchStats = useCallback(async () => {
    if (!settingId) {
      setStats(EMPTY_STATS);
      return;
    }
    const reqId = ++requestIdRef.current;
    setLoading(true);
    setError(null);
    try {
      const res = await chatbotApi.getStatsBySetting(settingId, {
        accountId,
        dateFrom,
        dateTo,
      });
      if (reqId !== requestIdRef.current) return;
      if (res.status !== 1) {
        throw new Error(res.message || "Không tải được thống kê");
      }
      setStats({ ...EMPTY_STATS, ...(res.data || {}) });
    } catch (err) {
      if (reqId !== requestIdRef.current) return;
      setError(err.message || String(err));
    } finally {
      if (reqId === requestIdRef.current) setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settingId, filterKey, accountId]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return { stats, loading, error, refresh: fetchStats };
};
